<template>
  <v-flex>
    <v-card v-if="!loading" class="pa-3">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :rows-per-page-items="[
          {
            text: 'Todos',
            value: -1,
          },
          5,
          10,
          25,
        ]"
        class="elevation-1"
      >
        <template v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            Nenhum registro encontrado.
          </v-alert>
        </template>
        <template slot="items" slot-scope="props">
          <td>
            <v-flex>
              <v-dialog v-model="props.item.dialog" width="500" :lazy="true">
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="
                      props.item.last_archive_today &&
                      props.item.list_status === 'done'
                    "
                    flat
                    dark
                    icon
                    v-on="on"
                    color="warning"
                    class="ma-0 pa-0"
                  >
                    <v-icon>cloud_upload</v-icon></v-btn
                  >
                </template>

                <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title
                    >Upload de lista - {{ props.item.id }}</v-card-title
                  >

                  <v-card-text>
                    <v-container grid-list-lg>
                      <v-text-field
                        label="Selecionar arquivo"
                        @click="onPickFile"
                        v-model="upload.fileName"
                        prepend-icon="attach_file"
                      ></v-text-field>
                      <!-- Hidden -->
                      <input
                        type="file"
                        style="display: none"
                        ref="fileInput"
                        accept="application/zip, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        @change="onFilePicked"
                      />
                      <v-btn
                        color="primary"
                        @click.stop="onAnalisysClick(props.item)"
                        :disabled="!upload.fileObject || dialog_loading"
                        class="ma-3"
                        >Analisar</v-btn
                      >

                      <!-- Kind of logs -->
                      <v-card
                        v-if="upload.name && !dialog_loading"
                        class="ma-3"
                      >
                        <v-card-title primary-title>
                          <h3 class="headline mb-0">Arquivo</h3>
                        </v-card-title>
                        <v-card-text v-if="upload.name"
                          >Nome: {{ upload.name }}</v-card-text
                        >
                        <v-card-text v-if="upload.size"
                          >Tamanho:
                          {{ Math.round((upload.size / 1024) * 10) / 10 }}
                          KB</v-card-text
                        >
                        <v-card-text v-if="upload.type"
                          >Tipo: {{ upload.type }}</v-card-text
                        >
                        <v-card-text v-if="upload.lastModifiedDate"
                          >Modificado em:
                          {{ upload.lastModifiedDate }}</v-card-text
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="error" flat @click="removeCurrentFile">
                            Remover
                          </v-btn>
                          <v-btn
                            color="success"
                            flat
                            @click="uploadNewReport(props.item)"
                          >
                            Enviar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                      <v-card v-if="dialog_loading">
                        <v-card-text>
                          <v-progress-linear
                            indeterminate
                            color="primary"
                          ></v-progress-linear>
                        </v-card-text>
                      </v-card>
                    </v-container>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="error"
                      flat
                      @click="props.item.dialog = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-snackbar :color="color" top v-model="snackbar" dark>
                  <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                  <div>{{ snackMessage }}</div>
                  <v-icon size="16" @click="snackbar = false">
                    mdi-close-circle
                  </v-icon>
                </v-snackbar>
              </v-dialog>
            </v-flex>
          </td>
          <td>
            {{ props.item.id }}

            <v-chip
              v-if="props.item.pp_status == 'inactivated'"
              color="error"
              text-color="white"
            >
              <v-avatar class="error darken-4">
                <v-icon color="white">error</v-icon> </v-avatar
              >Inativa</v-chip
            >
            <v-chip
              v-if="props.item.pp_status == 'awaiting'"
              color="warning"
              text-color="white"
            >
              <v-avatar class="error darken-4">
                <v-icon color="white">warning</v-icon> </v-avatar
              >Aguardando dados</v-chip
            >
          </td>
          <td>{{ props.item.installation_number }}</td>
          <td>
            <v-chip
              v-if="
                props.item.last_archive_today &&
                props.item.list_status === 'done'
              "
              color="success"
              text-color="white"
            >
              <v-avatar class="success darken-4">
                <v-icon color="white">check_circle</v-icon> </v-avatar
              >Enviada</v-chip
            >
            <v-chip v-else color="warning" text-color="white">
              <v-avatar class="warning darken-4">
                <v-icon color="white">warning</v-icon> </v-avatar
              >Pendente</v-chip
            >
            <v-chip
              v-if="
                props.item.list_status === 'failure' &&
                props.item.last_archive_today
              "
              outline
              color="error"
              text-color="error"
            >
              <v-avatar class="error outline">
                <v-icon color="white">build</v-icon> </v-avatar
              >Download automático falhou</v-chip
            >
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
  </v-flex>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Opções", value: "actions", sortable: false, width: "100px" },
        { text: "Usina", value: "id" },
        { text: "Número da instalação", value: "installation_number" },
        { text: "Status da lista", value: "last_archive_today" },
      ],
      items: [],
      lastModifiedDate: "",
      color: "",
      snackMessage: "",
      snackbar: false,
      allowedCemig: ["application/zip", "application/x-zip-compressed"],
      allowedNeoenergia: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
    };
  },
  created() {
    this.getGdReports();
  },
  watch: {
    getItems() {
      this.items = this.getItems;
    },
    getLoading() {
      this.loading = this.getLoading;
    },
  },
  computed: {
    ...mapState("billing", ["upload", "dialog_loading"]),
    ...mapGetters("billing", [
      "getItems",
      "loading",
      "dialog_loading",
      "getUploadStatus",
      "getUpload",
    ]),
  },
  methods: {
    ...mapActions("billing", [
      "getGdReports",
      "uploadGdReport",
      "uploadNeoenergiaBA",
    ]),
    ...mapMutations("billing", [
      "_setItems",
      "setLoading",
      "setDialogLoading",
      "setFileObject",
      "removeCurrentFile",
    ]),
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      if (files[0] !== undefined) {
        this.upload.fileName = files[0].name;

        // Check validity of file
        if (this.upload.fileName.lastIndexOf(".") <= 0) {
          return;
        }

        // If valid, continue
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.upload.url = fr.result;
          this.upload.fileObject = files[0]; // this is an file that can be sent to server...
        });
      } else {
        return;
      }
    },
    async onAnalisysClick(item) {
      this.$store.commit("billing/setDialogLoading", true);

      let allowedMimeTypes = [
        "application/zip",
        "application/x-zip-compressed",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (item.utility_company === "cemig") {
        allowedMimeTypes = this.allowedCemig;
      } else if (
        item.utility_company === "neoenergia-pe" ||
        item.utility_company === "neoenergia-ba"
      ) {
        allowedMimeTypes = this.allowedNeoenergia;
      } else {
        this.snack("Concessionária não cadastrada", "error");
        this.$store.commit("billing/setDialogLoading", false);
        return;
      }

      console.log(this.upload.fileObject);
      // A file is not chosen!
      if (!this.upload.fileObject) {
        this.$store.commit("billing/setDialogLoading", false);
        return;
      }
      if (this.upload.fileObject.size > 10000000) {
        this.snack("O arquivo deve ter no máximo 10MB.", "error");
        this.$store.commit("billing/setDialogLoading", false);
        return;
      }
      if (!allowedMimeTypes.includes(this.upload.fileObject.type)) {
        this.snack(
          "O arquivo deve ser um zip (cemig) ou xlsx (neoenergia)!",
          "error",
        );
        this.$store.commit("billing/setDialogLoading", false);
        return;
      }
      // DO YOUR JOB HERE with upload.fileObjectToUpload
      // https://developer.mozilla.org/en-US/docs/Web/API/File/File
      this.upload.name = this.upload.fileObject.name;
      this.upload.size = this.upload.fileObject.size;
      this.upload.type = this.upload.fileObject.type;

      this.upload.lastModifiedDate =
        moment(this.upload.fileObject.lastModifiedDate).format(
          "DD/MM/YYYY HH:mm:ss",
        ) ?? "";
      // DO YOUR JOB HERE with fileObjectToUpload
      this.$store.commit("billing/setDialogLoading", false);
    },
    async uploadNewReport(item) {
      try {
        const now = new Date();
        const fileDate = moment(this.upload.fileObject.lastModifiedDate).format(
          "YYYY-MM-DD",
        );

        let response;
        if (item.utility_company === "neoenergia-ba") {
          const converted_file = await this.convertFileToBase64(
            this.upload.fileObject,
          );
          response = await this.uploadNeoenergiaBA({
            file: converted_file,
            power_plant_id: item.id,
          });
        } else {
          response = await this.uploadGdReport({
            power_plant_id: item.id,
            file: this.upload.fileObject,
            installation_number: item.installation_number,
            date: item.utility_company === "neoenergia-pe" ? fileDate : now,
          });
        }
        this.$store.commit("billing/removeCurrentFile");
        setTimeout(() => {
          this.getGdReports();
          this.snackbar = false;
        }, 3000);

        if (response.status === 200) {
          this.snack("Arquivo enviado com sucesso!", "success");
        } else {
          this.snack(
            "Erro ao enviar arquivo! Por favor verifique se é o arquivo correto e tente novamente.",
            "error",
          );
        }
      } catch (error) {
        console.error(error);
      }
    },

    removeCurrentFile() {
      this.$store.commit("billing/removeCurrentFile");
    },

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    async convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>

<style scoped>
.v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table__wrapper table {
  min-width: 100%;
}
</style>
